export default __webpack_public_path__ + "static/media/smc.6be5008b.svg";